import LandingPageLayout from 'components/LandingPageLayout';
import VideoDeepReview from 'components/LandingPageVideoDeepReview';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import AboutUs from 'components/LandingPageAboutUs';
import ClientSlider from 'components/LandingPageCarousels/ClientSlider';
import ReservationForm from '../components/LandingPageReservationForm';
import React from 'react';
import ArrivePays from 'components/LandingPageArrivePays';
import ImageBox from 'components/LandingPageImageBox';
import TitleBgYellow from 'components/LandingPageTitleSection/TitleBgYellow';
import Head from 'next/head';
import Requirements from 'components/LandingPageRequirements';
const Arrive = () => {
  const clientsData = [
    {
      id: 1,
      image: 'pivot.png',
      name: 'client-1',
    },
    {
      id: 2,
      image: 'rental.png',
      name: 'client2',
    },
    {
      id: 3,
      image: 'globe.png',
      name: 'client-3',
    },
    {
      id: 4,
      image: 'nationalposts.png',
      name: 'client-4',
    },
    {
      id: 5,
      image: 'toronto.png',
      name: 'client-5',
    },
    {
      id: 6,
      image: 'rental.png',
      name: 'client-6',
    },
  ];
  const id = 'form';
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Arrive in style</title>
        <meta
          name="description"
          content="Select from a range of verified properties and rooms from verified landlords in the city."
        />
        
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/arrive" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Arrive in style" />
        <meta
          property="og:description"
          content="Select from a range of verified properties and rooms from verified landlords in the city."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Select from a range of verified properties and rooms from verified landlords in the city."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />

        <link rel="canonical" href="https://www.soulrooms.com/arrive" />
      </Head>
      <LandingPageLayout>
        <TitleBgYellow />

        <VideoDeepReview
          btnLink={id}
          title="LIVE HASSLE FREE IN TORONTO "
          details=" Accommodations for young professionals & new immigrants in great properties promoted by amazing landlords in the city.  "
          bg="white"
        />

        {/* CLIENT SLIDER  */}
        <HeadingSection title="AS FEATURED IN:" bgcolor="white" />
        <ClientSlider classN="clients-brand-carousel" clientsData={clientsData} icons={false} />

        <ImageBox />

        <ArrivePays
          title="WHAT YOU GET?"
          imgOne="/static/images/landingPages/arrive1.png"
          headingOne="Virtual tours & remote viewing"
          txtOne="You can experience any SoulRoom virtually or via a remote showing done by one of our representatives. Explore, walk-through (virtually), and book your stay in some of the great homes listed by amazing landlords from the comfort of your home."
          imgTwo="/static/images/landingPages/arrive2.png"
          headingTwo="Online booking & easy documentation"
          txtTwo="Complete documentation and booking process is seamlessly designed
           online to help you get your SoulRoom without the hassle. Pay using any
            credit card for your booking and select from a number of accepted 
            documents* to complete your it."
          imgFive="/static/images/landingPages/arrive5.png"
          headingFive="Your community in Canada"
          txtFive="SoulRooms is the home to young 
          professionals from 25 different nationalities,
           working across various industries from banking to
            performing arts. Come home to a curated community 
            of individuals, you can proudly call your family in Canada."
        />

        {/* RESERVATION FORM  */}
        <div id={id}>
          <ReservationForm heading="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
            <iframe
              id="JotFormIFrame-91797058303261"
              title="Find a SoulRoom"
              onLoad={() => {
                window.parent.scrollTo(0, 0);
              }}
              allowTransparency="true"
              allowFullScreen="true"
              allow="geolocation; microphone; camera"
              src="https://form.jotform.com/91797058303261"
              frameBorder="0"
              style={{ minWidth: '100%', height: '640px', border: 'none' }}
              scrolling="no"></iframe>
          </ReservationForm>
        </div>

        {/* ABOUT US SECTION  */}
        <AboutUs bg="false" />

        <Requirements />
      </LandingPageLayout>
    </>
  );
};

export default Arrive;
